<template>
    <!--  -->
    <div class="row" v-if="userStore.user.ownerHasAttorney && !userStore.user.is_power_of_attorney_signed">
        <div class="col-12 col-sm-offset-2 col-sm-12 col-md-12 col-lg-offset-2 col-lg-12 mx-auto">
            <div class="card basic-pricing text-center">
                <div class="card-body d-flex justify-content-between align-items-center">
                    <h4 class="text-warning">
                        <vue-feather type="info" style="overflow: visible;" class="mr-50 align-middle top-0 text-warning" />
                        Click the button to sign The Power Of Attorney
                    </h4>
                    <button type="submit" class="btn btn-primary mr-md-1 mb-1 mb-sm-0" @click="$router.push({'name':'power-of-attorney'})">Sign Power Of Attorney</button>
                </div>
            </div>
        </div>
    </div>
    <!--/ pricing plan cards -->
    <!-- <div class="modal fade" ref="clientContract" :id="id">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header bg-transparent">
                    <button @click="closeModal('#' + id)" type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body px-sm-2 mx-50 pb-5">
                    <contract-info-component/>
                </div>
            </div>
        </div>
    </div> -->
</template>
<script>
    import ContractInfoComponent from "./ContractInfoComponent.vue"
    import { ref, reactive } from 'vue';
    import { useClientStore } from "../../stores/ClientStore.js";
    import { useLocalizationStore } from '../../stores/LocalizationStore.js'
    import { useStateStore } from '../../stores/StateStore.js'
    import { useUserStore } from "../../stores/UserStore.js";
    import { closeModal, openModal, hideModal } from '../../utilities/_helpers'
    import { useRoute, useRouter } from "vue-router";
    import useVuelidate from '@vuelidate/core'
    import { required, email } from '@vuelidate/validators'
    import Swal from 'sweetalert2'
    export default {
        components: {
            ContractInfoComponent
        },
        setup(){
            return {
                route : useRoute(),
                router : useRouter(),
                closeModal: closeModal,
                localizationStore: useLocalizationStore(),
                stateStore: useStateStore(),
                userStore : useUserStore(),
                useProfileInformation: ref(false),
                openModal: openModal,
                hideModal: hideModal,
                id: 'client-contract-modal',

            }
        },
        watch: {
        },
        mounted(){
        },
        methods:{
        }
    }
</script>
